var React = require('react');

function LocationDropPinInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M12 23c.418 0 8-9.582 8-14A8 8 0 1 0 4 9c0 4.418 7.582 14 8 14z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4z","fill":"currentColor","key":1})]));
}

LocationDropPinInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = LocationDropPinInline;

LocationDropPinInline.default = LocationDropPinInline;
